export const version = '2.87.0' // bump-client-version 2026-05-26T17:05:34.250Z
